import React, { useState, useEffect,useContext } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';
import UserContext from '../../contexts/UserContext'

const SupplierDetails = () => {
  const { state } = useLocation();
  const { supplier } = state;
  const navigate = useNavigate();
  const {user,setUser} = useContext(UserContext);


  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
      if(user){
        
      }
    }
    startup();
  },[user])

  const getPurchaseTypeColor = (purchaseType) => {
    switch (purchaseType) {
      case 'zone':
        return 'bg-blue-500 text-blue-100';
      case 'central':
        return 'bg-teal-600 text-teal-100';
      default:
        return 'bg-blue-500 text-blue-100'; // Default color if purchaseType is not recognized
    }
  };

  const handleAddItemsClick = () => {
    navigate('addItems', { state: { supplier } });
  };
  
  return (
    <div className="w-full">
      <div className="mb-6 bg-lime-800 p-4 flex items-center">
        <div className="mr-4 cursor-pointer" onClick={() => navigate(-1)}>
          <span className="text-xl text-white">←</span>
        </div>
        <div className="flex-grow text-center">
          <h2 className="text-2xl font-semibold text-white mb-2">{supplier.company}</h2>
          <div className="flex flex-col md:items-center md:justify-between">
            <span className="text-sm text-lime-300">Supplier Name :</span>
            <span className="text-lg text-white"><strong>{supplier.name}</strong></span>
            <span className="text-sm text-lime-300 mt-3">Address :</span>
            <span className="text-lg text-white">{supplier.address}</span>
          </div>
        </div>
      </div>
      <h3 className="text-xl font-semibold text-gray-800 px-4">Items</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 p-4">
        {supplier.items.map(item => (
          <div key={item._id} className="p-4 bg-white rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-2">
              <span className="text-lg font-semibold text-fmb">{item.name}</span>
              {item.purchaseType && (
                <span className={`text-sm font-medium px-3 py-1 rounded-full ${getPurchaseTypeColor(item.purchaseType)}`}>
                  {item.purchaseType}
                </span>
              )}
            </div>
            <div className="text-gray-600">
              <p><strong>Category:</strong> {item.category}</p>
              <p><strong>Unit:</strong> {item.unit}</p>
            </div>
          </div>
        ))}
      </div>
<div className='flex justify-center mt-6'>
<button
        onClick={handleAddItemsClick}
        className="mt-6 px-4 py-2 bg-fmb text-white rounded-full shadow hover:bg-yellow-500 font-semibold"
      >
        Add Items
      </button>
</div>
    </div>
    
  );
};

export default SupplierDetails;